import React, { ChangeEvent, FormEvent } from 'react';
import { Typography, makeStyles, TextField, Grid, Button, InputLabel, Theme } from '@material-ui/core';
import { useAppState } from '../../../state';

const useStyles = makeStyles((theme: Theme) => ({
  gutterBottom: {
    // marginBottom: '1em',
  },
  inputContainer: {
    display: 'inline',
    justifyContent: 'space-between',
    margin: '1 em 0 3 em',
    '& div:not(:last-child)': {
      marginRight: '1em',
      marginTop: '1em',
      marginBottom: '1em',
    },
    [theme.breakpoints.down('sm')]: {
      margin: '1.5em 0 2em',
    },
  },
  textFieldContainer: {
    width: '100%',
  },
  continueButton: {
    display: 'center',
    marginRight: '1em',
    marginTop: '1em',
    marginBottom: '1em',
    [theme.breakpoints.down('sm')]: {
      margin: '1.5em 0 2em',
    },
  },
}));

interface RoomNameScreenProps {
  name: string;
  roomName: string;
  roomPassword: string;
  setName: (name: string) => void;
  setRoomName: (roomName: string) => void;
  setRoomPassword: (roomPassword: string) => void;
  handleSubmit: (event: FormEvent<HTMLFormElement>) => void;
}

export default function RoomNameScreen({
  name,
  roomName,
  roomPassword,
  setName,
  setRoomName,
  setRoomPassword,
  handleSubmit,
}: RoomNameScreenProps) {
  const classes = useStyles();
  const { user } = useAppState();

  const handleNameChange = (event: ChangeEvent<HTMLInputElement>) => {
    setName(event.target.value);
  };

  const handleRoomNameChange = (event: ChangeEvent<HTMLInputElement>) => {
    setRoomName(event.target.value);
  };

  const handleRoomPasswordChange = (event: ChangeEvent<HTMLInputElement>) => {
    setRoomPassword(event.target.value);
  };

  const hasUsername = !window.location.search.includes('customIdentity=true') && user?.displayName;

  return (
    <>
      <Typography variant="h5" className={classes.gutterBottom}>
        Join a Room
      </Typography>
      <Typography variant="body1">
        {hasUsername
          ? "Enter the name of a room you'd like to join."
          : "Enter your name and the name of a room you'd like to join"}
      </Typography>
      <form onSubmit={handleSubmit}>
        <div className={classes.inputContainer}>
          {!hasUsername && (
            <div className={classes.textFieldContainer}>
              <InputLabel shrink htmlFor="input-user-name">
                Your Name
              </InputLabel>
              <TextField
                id="input-user-name"
                variant="outlined"
                fullWidth
                size="small"
                value={name}
                onChange={handleNameChange}
              />
            </div>
          )}
          <div className={classes.textFieldContainer}>
            <InputLabel shrink htmlFor="input-room-name">
              Room Name
            </InputLabel>
            <TextField
              autoCapitalize="false"
              id="input-room-name"
              variant="outlined"
              fullWidth
              size="small"
              value={roomName}
              onChange={handleRoomNameChange}
            />
          </div>
          <div className={classes.textFieldContainer}>
            <InputLabel shrink htmlFor="input-room-password">
              Room Password
            </InputLabel>
            <TextField
              autoCapitalize="false"
              id="input-room-password"
              variant="outlined"
              fullWidth
              size="small"
              value={roomPassword}
              onChange={handleRoomPasswordChange}
            />
          </div>
        </div>
        <Grid container justifyContent="center" spacing={2}>
          <Button
            variant="contained"
            type="submit"
            color="primary"
            disabled={!name || !roomName || !roomPassword}
            className={classes.continueButton}
          >
            Continue
          </Button>
        </Grid>
      </form>
    </>
  );
}
